// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyBlk3mf9_w9tdN1K5aWX42L4CU3TXN9uZ0",
    authDomain: "loans-pwa.firebaseapp.com",
    projectId: "loans-pwa",
    storageBucket: "loans-pwa.appspot.com",
    messagingSenderId: "952213417774",
    appId: "1:952213417774:web:aaec71b962a5b20eb1d4bf",
    measurementId: "G-MZHPWJH9S3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export default {
    sendEvent(name) {
        logEvent(analytics, name);
    }
}